import axios from 'axios';
import {
  FETCH_HOLIDAYS_START,
  FETCH_HOLIDAYS_SUCCESS,
  FETCH_HOLIDAYS_FAILURE,
} from './types';

// eslint-disable-next-line import/prefer-default-export
export const fetchHolidays = () => dispatch => {
  dispatch({ type: FETCH_HOLIDAYS_START });
  axios
    .get(`/api/holidays`)
    .then(({ data }) => {
      dispatch({ type: FETCH_HOLIDAYS_SUCCESS, payload: data });
    })
    .catch(err => {
      const errorCode = err?.response?.data?.errorCode;
      dispatch({
        type: FETCH_HOLIDAYS_FAILURE,
        payload: { errorCode },
      });
    });
};
